import React from 'react';
import css from './FilterPanel.module.css';
import { PrimaryButton, SecondaryButton } from '../../../components';
import { FormattedMessage } from 'react-intl';

const BottomButtons = ({ submitFilters, resetAll }) => {
  return (
    <div className={css.rootBottomPanel}>
      <SecondaryButton onClick={resetAll}>
        <FormattedMessage id="Cappa.resetAllFilters" defaultMessage={'Reset all filters'} />
      </SecondaryButton>
      <PrimaryButton onClick={submitFilters}>
        <FormattedMessage id="Cappa.applyFilter" defaultMessage={'Apply'} />
      </PrimaryButton>
    </div>
  );
};

export default BottomButtons;
